if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"gizmo_web","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(18[08]3|2263|4115|4480|7087|9121)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}